import React from 'react'

const LogoSection: React.FC = () => {
  const logos = [
    { src: "/logos/ireo-logo.webp", alt: "IREO" },
    { src: "/logos/nc.jpg", alt: "NC Realty" },
    { src: "/logos/dlf.png", alt: "DLF" },
    { src: "/logos/Landmark-Group-Logo.jpg", alt: "Landmark" },
    { src: "/logos/country group.png", alt: "County Group" },
    { src: "/logos/m3m.jpg", alt: "M3M" },
    { src: "/logos/signature global.jpg", alt: "Signature Global" },
    { src: "/logos/Godrej_Logo.svg.png", alt: "Godrej" },
    { src: "/logos/whiteland.svg", alt: "Whiteland" },
    { src: "/logos/sobha.png", alt: "Sobha" }
  ]

  // Create multiple sets for smoother animation
  const logoSets = [logos, logos, logos]

  return (
    <section className="py-12 bg-white border-b border-gray-100 overflow-hidden">
      <div className="container-custom mb-8">
        <p className="text-center text-gray-600 uppercase tracking-widest text-sm font-medium">Trusted by Industry Leaders</p>
      </div>

      <div className="relative w-full overflow-hidden">
        {/* Gradients for smooth edges */}
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10"></div>
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10"></div>

        <div className="flex animate-marquee hover:pause-animation">
          {logoSets.flat().map((logo, index) => (
            <div key={`logo-${index}`} className="flex-shrink-0 mx-8 md:mx-12 grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100">
              <img
                src={logo.src}
                alt={logo.alt}
                className="h-10 md:h-12 w-auto object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default LogoSection
